export const GET_BRANCHES = "get_branches";
export const START_LOADING = "start_loading";
export const STOP_LOADING = "stop_loading";
export const GET_RESOURCE_PLANNING = "get_resource_planning";
export const ERROR = "error";
